module.exports = __webpack_public_path__ + "media/bootstrap-icons/hand-thumbs-down-fill-65419238.svg";